export const UI_TEXT = {
  loading: "Loading Workivity detail screen...",
  brand: "Worktivity",
  menuAriaLabel: "menu",
  menuTrigger: "...",
  menuOrgName: "DigiTechIO",
  menuOrgRole: "Employee / Admin",
  menuItems: {
    activities: "My activities",
    settings: "Settings",
    checkForUpdate: "Check for update",
    checkingForUpdate: "Checking for update...",
    signOut: "Sign-out",
  },
  updateCheck: {
    upToDate: "You're up to date",
    failed: "Couldn't check for updates",
  },
  welcomePrefix: "Welcome,",
  welcomeName: "Ammad",
  timeLabels: {
    hours: "hours",
    minutes: "minutes",
    seconds: "seconds",
  },
  breakRunningFor: "Break running for",
  actions: {
    takeBreak: "Take a break",
    resumeWork: "Resume work",
    clockIn: "Clock-in",
    clockOut: "Clock-out",
  },
  workNotePlaceholder: "Work note...",
  errorPrefix: "Something went wrong",
  errors: {
    loadDashboard: "Could not load dashboard detail.",
    updateBreakStatus: "Could not update break status.",
    updateClockStatus: "Could not update clock status.",
  },
  theme: {
    ariaLabel: "Toggle theme",
    darkTitle: "Switch to light mode",
    lightTitle: "Switch to dark mode",
    darkIcon: "🌙",
    lightIcon: "☀️",
  },
  adminVerify: {
    heading: "Admin verification required",
    description: "Enter an admin's email and password to sign out.",
    emailPlaceholder: "Admin email",
    passwordPlaceholder: "Admin password",
    cancel: "Cancel",
    submit: "Verify & sign out",
    submitting: "Verifying...",
    genericError: "Verification failed. Check your connection and try again.",
  },
};

const WEB_PORTAL_ORIGIN =
  process.env.REACT_APP_WEB_PORTAL_ORIGIN || "http://localhost:3000";

export const WEB_LINKS = {
  activities:
    process.env.REACT_APP_ACTIVITIES_URL || `${WEB_PORTAL_ORIGIN}/my-activities`,
  settings:
    process.env.REACT_APP_SETTINGS_URL || `${WEB_PORTAL_ORIGIN}/settings`,
};
